module.exports = __webpack_public_path__ + "static/media/hero_tagline.e8cd406b.svg";